module.exports = __webpack_public_path__ + "img/sentorini_canopy.f57c45ea.jpg";